import { useMutation, type UseMutationResult } from "@tanstack/react-query";

import { ENDPOINTS } from "@/api/application-api";
import { useAuth } from "@/context/auth-context";
import { handleResponse } from "@/utils/errorResponseHandlers";
import { jsonAuthHeaders } from "@/utils/headers";

interface LinkSlackAccountResponse {
  success: boolean;
}

export const useLinkSlackAccount = (): UseMutationResult<
  LinkSlackAccountResponse,
  Error,
  string
> => {
  const auth = useAuth();
  const userToken = auth?.userToken ?? "";

  return useMutation({
    mutationFn: async (token: string): Promise<LinkSlackAccountResponse> => {
      const res = await fetch(ENDPOINTS.slack.linkAccount, {
        method: "POST",
        headers: jsonAuthHeaders(userToken),
        body: JSON.stringify({ token }),
      });
      return handleResponse(res);
    },
  });
};
